function cleanString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function firstNonEmpty(...values) {
  for (const value of values) {
    const normalized = cleanString(value);
    if (normalized) return normalized;
  }
  return '';
}

function normalizeGeo(rawGeo) {
  if (!rawGeo || typeof rawGeo !== 'object') return null;

  const lat = Number(rawGeo.lat ?? rawGeo.latitude);
  const lng = Number(rawGeo.lng ?? rawGeo.lon ?? rawGeo.longitude);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  return { lat, lng };
}

export function normalizeAddress(input = {}) {
  const source = typeof input === 'string'
    ? { street: input }
    : (input && typeof input === 'object' ? input : {});
  const nestedAddress = source.address && typeof source.address === 'object'
    ? source.address
    : {};

  const line1 = firstNonEmpty(source.line1, source.addressLine1, nestedAddress.line1, nestedAddress.addressLine1);
  const line2 = firstNonEmpty(source.line2, source.addressLine2, nestedAddress.line2, nestedAddress.addressLine2);
  const street = firstNonEmpty(
    source.street,
    nestedAddress.street,
    [line1, line2].filter(Boolean).join(', ')
  );

  return {
    street,
    city: firstNonEmpty(source.city, source.town, source.locality, nestedAddress.city, nestedAddress.town, nestedAddress.locality),
    state: firstNonEmpty(
      source.state,
      source.stateProvince,
      source.county,
      source.province,
      nestedAddress.state,
      nestedAddress.stateProvince,
      nestedAddress.county,
      nestedAddress.province
    ),
    postcode: firstNonEmpty(
      source.postcode,
      source.postal_code,
      source.postalCode,
      source.zip,
      source.zipCode,
      nestedAddress.postcode,
      nestedAddress.postal_code,
      nestedAddress.postalCode,
      nestedAddress.zip,
      nestedAddress.zipCode
    ),
    country: firstNonEmpty(source.country, source.countryCode, nestedAddress.country, nestedAddress.countryCode),
    geo: normalizeGeo(source.geo || source.coordinates || nestedAddress.geo || nestedAddress.coordinates),
    geoLabel: firstNonEmpty(source.geoLabel, source.geocodeLabel, nestedAddress.geoLabel, nestedAddress.geocodeLabel),
  };
}
